module.exports = __webpack_public_path__ + "static/media/rbup.6f96c99d.gif";